<template>
    <div id="course">
        <loadings v-if="loading"></loadings>
        <template v-else>

            <div class="rate">
                <div>
                    <h3>{{0}}<span>%</span></h3>
                    <p>平均得分率</p>
                </div>
                <div>
                    <h3>{{0}}<span>%</span></h3>
                    <p>班级优秀率</p>
                </div>
                <div>
                    <h3>{{0}}<span>%</span></h3>
                    <p>班级合格率</p>
                </div>
            </div>

            <sharestu v-if="tabtype==1"
                      :message_id='this.taskId'
                      :score_group='ecData.score_group'
                      :unit_score_rate='ecData.unit_score_rate'
                      :is_correct_user='is_correct_user'
                      :is_not_correct_user='is_not_correct_user'></sharestu>

        </template>
    </div>
</template>

<script>
import loadings from "COMPONENTS/base/loadingS.vue";
import sharestu from "./module/shareStu.vue";
export default {
    components: {
        loadings,
        sharestu,
    },

    data () {
        return {
            title: 'XXX班作业报告',
            loading: true,
            status: 0,
            tabtype: 1,
            sid: this.$route.query.sid,
            taskId: this.$route.query.taskId,
            classId: this.$route.query.classId,
            taskType: this.$route.query.taskType,
            stuData: {},//按学生查看数据
            fromPath: '',
            fromData: {},
        }
    },


    mounted () {
        this.getClassData()
        document.title = `${this.$route.query.className}班作业报告`
    },
    methods: {
        getClassData () {
            let data = {}, url = "";
            data = {
                "message_id": this.taskId,
                "unit_class_id": this.classId
            }
            if (this.sid == 51) {
                url = '/chinese/check/special/task_detail/';
            }
            else if (this.sid == 21) {
                url = '/maths/check/special/task_detail/'
            }
            this.$http.post(API_URL_TASK_API + url, data).then(res => {
                if (res.data.response == 'ok') {
                    this.loading = false
                    this.ecData = res.data.data
                    this.is_not_correct_user = res.data.data.is_not_correct_user
                    this.is_correct_user = res.data.data.is_correct_user
                }
            })
        },


    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.head {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100vw;
    height: 96px / $ppr;
    background: #5e89ef;

    .back {
        position: absolute;
        top: 30px / $ppr;
        left: 24px / $ppr;
        width: 18px / $ppr;
        height: 34px / $ppr;
        background: url(./img/choose_back.png) no-repeat;
        background-size: 100% 100%;
    }

    .title {
        width: 100%;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        font-size: 34px / $ppr;
        color: #fff;
        text-align: center;
    }

    .preview {
        position: absolute;
        top: 30px / $ppr;
        right: 24px / $ppr;
        z-index: 10;
        font-size: 30px / $ppr;
        color: #fff;
    }
}
#course {
    padding-bottom: 30px / $ppr;
    width: 100%;
    overflow-x: hidden;
    padding-top: 30px / $ppr;
}
.list {
    // width:660px/$ppr;
    width: 100%;
    margin: 0 auto;
    height: 120px / $ppr;
    position: relative;
    &::before {
        display: block;
        width: 30px / $ppr;
        height: 120px / $ppr;
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        z-index: 5;
        background-image: linear-gradient(
            to left,
            rgba(247, 248, 249, 1) 0%,
            rgba(247, 248, 249, 0) 100%
        );
    }
    &::after {
        display: block;
        width: 30px / $ppr;
        height: 120px / $ppr;
        content: "";
        position: absolute;
        right: 0;
        top: 0;
        z-index: 5;
        background-image: linear-gradient(
            to left,
            rgba(247, 248, 249, 0) 0%,
            rgba(247, 248, 249, 1) 100%
        );
    }
    .list_warp {
        position: relative;
        overflow-x: auto;
        height: 60px / $ppr;
        padding: 30px / $ppr 0;
        overflow-y: hidden;
        &::-webkit-scrollbar {
            display: none;
        }
        .list_item {
            position: absolute;
            top: 30px / $ppr;
            left: 30px / $ppr;
            overflow-x: auto;
            white-space: nowrap;
            display: flex;
            height: 60px / $ppr;
            span {
                display: block;
                // float: left;
                width: 120px / $ppr;
                height: 60px / $ppr;
                line-height: 60px / $ppr;
                background: #fff;
                border-radius: 8px / $ppr;
                margin-right: 24px / $ppr;
                text-align: center;
                color: #7b84a0;
                font-size: 26px / $ppr;
                &.active {
                    background: #0f8fff;
                    color: #fff;
                }
            }
        }
    }
}
.box {
    width: 600px / $ppr;
    margin: 0 auto 30px / $ppr;
    background: #fff;
    padding: 25px / $ppr 30px / $ppr 46px / $ppr;
    border-radius: 16px / $ppr;
    h3 {
        font-size: 30px / $ppr;
        margin-bottom: 24px / $ppr;
        line-height: 56px / $ppr;
        position: relative;
        padding-left: 48px / $ppr;
        font-weight: bold;
        i {
            position: absolute;
            left: 0;
            top: 50%;
            margin-top: -17px / $ppr;
            display: block;
            width: 32px / $ppr;
            height: 32px / $ppr;
            background: url("./img/icon03.png") 0 0 no-repeat;
            background-size: 100% 100%;
        }
    }
}
.rate {
    width: 690px / $ppr;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    div {
        background-image: linear-gradient(#fff, #f7f8f9);
        width: 220px / $ppr;
        text-align: center;
        padding: 30px / $ppr 0 50px / $ppr;
        &:nth-child(1) {
            h3 {
                color: #3c7cfb;
            }
        }
        &:nth-child(2) {
            h3 {
                color: #4ecb39;
            }
        }
        &:nth-child(3) {
            h3 {
                color: #ffaf5a;
            }
        }
        h3 {
            line-height: 66px / $ppr;
            font-size: 56px / $ppr;
            font-weight: bold;
            span {
                font-size: 32px / $ppr;
                font-weight: normal;
            }
        }
        p {
            font-size: 24px / $ppr;
            color: #999;
        }
    }
}
.tab {
    width: 544px / $ppr;
    height: 54px / $ppr;
    margin: 0 auto;
    border: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    border-radius: 28px / $ppr;
    p {
        // float: left;
        width: 180px / $ppr;
        line-height: 54px / $ppr;
        font-size: 24px / $ppr;
        color: #888;
        text-align: center;
        &:nth-child(1) {
            border-top-left-radius: 28px / $ppr;
            border-bottom-left-radius: 28px / $ppr;
        }
        &:nth-child(2) {
            border-left: 1px solid #eee;
            border-right: 1px solid #eee;
        }
        &:nth-child(3) {
            border-top-right-radius: 28px / $ppr;
            border-bottom-right-radius: 28px / $ppr;
        }
        &.active {
            background: #e7f4ff;
            color: #0f8fff;
        }
    }
}
.white_bg {
    background: #fff;
}
.dighol_span_number {
}
.scoreChartWarp {
    width: 600px / $ppr;
    margin: 0 auto;
    overflow-x: auto;
}
.btm-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 20px / $ppr 32px / $ppr;
    background: #fff;
    box-sizing: border-box;
    p {
        background: #0f8fff;
        color: #fff;
        font-size: 30px / $ppr;
        line-height: 80px / $ppr;
        border-radius: 80px / $ppr;
        text-align: center;
    }
}
</style>